import ShowcaseGallery from "../../ShowcaseGallery";
import { useScreenSize } from "../../../hooks/useScreenSize";
import ImageCard from "../../shared/ImageCard";
import { Link } from "@inertiajs/react";
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function HeroSection({
  heroSectionData,
  topRibbon,
}: any) {
  const { screenLargerThan } = useScreenSize();
  const isSmall = !screenLargerThan('sm');

  return (
    <div className="hero bg-base-300" style={{
    }}>
      <div className="hero-content flex-col lg:flex-row w-full justify-between px-4 py-6" style={{
        alignItems: 'flex-start',
        height: isSmall ? 'auto' : '100%',
        gap: isSmall ? '2rem' : '3rem',
        maxWidth: '100%',
        overflow: 'hidden',
        padding: isSmall ? '25px 20px' : '20px 100px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '0.5rem',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'hidden',
        }}>
          <p className="" style={{ gridColumn: '1' }}>
            {heroSectionData.subtitle}
          </p>
          <h1 className="text-3xl sm:text-5xl font-bold" style={{
            gridColumn: '1',
            margin: 0
          }}>
            {heroSectionData.heading}
          </h1>
          <div style={{ display: 'flex', flexDirection: isSmall ? 'column' : 'row', flexWrap: 'wrap', gap: isSmall ? '4px' : '12px', alignItems: isSmall ? 'flex-start' : 'center' }}>
            {topRibbon?.address && (
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('dayrna')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="link opacity-70"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: isSmall ? '0.8rem' : '0.9rem',
                }}
              >
                <FontAwesomeIcon icon={faMapMarkerAlt} size="sm" />
                {topRibbon.address}
              </a>
            )}
            {topRibbon?.phone && (
              <a
                href={`tel:${topRibbon.phone}`}
                className="link opacity-70"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: isSmall ? '0.8rem' : '0.9rem',
                }}
              >
                <FontAwesomeIcon icon={faPhone} size="sm" />
                {topRibbon.phone}
              </a>
            )}
          </div>
          <p className="pt-4 pb-3" style={{
            gridColumn: '1',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto'
          }}>
            {heroSectionData.description}
          </p>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'space-between'
          }}>
            <Link
              href={heroSectionData.button_link || '#'}
              className="btn btn-primary"
              style={{ gridColumn: '1', justifySelf: 'start' }}
            >
              {heroSectionData.button_text}
            </Link>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isSmall ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: isSmall ? '10px' : '15px',
            marginTop: isSmall ? '15px' : '20px',
            width: '100%',
          }}>
            <ImageCard
              backgroundImage={'https://media.gettyimages.com/id/1725905443/photo/vatican-city-vatican-cardinal-b%C3%A9chara-boutros-ra%C3%AF-the-maronite-patriarch-of-antioch-presides.jpg?s=612x612&w=gi&k=20&c=XQfFuv_paSeDhU7966eOFa_u6c4ZGqhEGFSrJ_ilMXM='}
              title="Messes"
            >
              <ImageCard.Content>
                <ImageCard.Description>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}>
                    <div style={{
                      flex: 1
                    }}>
                      <strong>Lundi au Samedi</strong>
                      <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                        {heroSectionData.mass_schedule.weekday}
                      </h2>
                    </div>
                    <div style={{
                      flex: 1
                    }}>
                      <strong>Dimanche</strong>
                      <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                        {heroSectionData.mass_schedule.sunday}
                      </h2>
                    </div>
                  </div>
                </ImageCard.Description>
              </ImageCard.Content>
            </ImageCard>

            <ImageCard
              backgroundImage={'https://dayrna.ca/_assets/images/slider/mazar-slider-1.jpg'}
              title="Sanctuaire des Saints"
            >
              <ImageCard.Content>
                <ImageCard.Description>
                  <div style={{
                    textAlign: 'center'
                  }}>
                    <strong>Lundi à Dimanche</strong>
                    <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                      {heroSectionData.sanctuary_hours}
                    </h2>
                  </div>
                </ImageCard.Description>
              </ImageCard.Content>
            </ImageCard>

          </div>
        </div>

        <div
          className="shadow-2xl"
          style={{
            width: '100%',
            maxWidth: isSmall ? '100%' : '650px',
            minWidth: 0,
            flexShrink: isSmall ? 0 : 1,
            height: isSmall ? '300px' : '100%',
            aspectRatio: isSmall ? undefined : '16 / 9',
            overflow: 'hidden',
          }}>
          <ShowcaseGallery attachments={heroSectionData.gallery_images} />
        </div>
      </div>
    </div>
  )
}
